import React from "react";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

export default function Electricity(props) {
	const { selkwh, selirr, parentKWHChange, parentIrrHardwareChange } = props;

	const [monthlyKWh, setMonthlyKWh] = React.useState(selkwh);
	const [irrHardware, setIrrHardware] = React.useState(selirr);

	const handleKwhMonthChange = (index, value) => {
		const newMonthlyKWh = [...monthlyKWh];
		if (value === "") {
			newMonthlyKWh[index] = null;
		} else {
			newMonthlyKWh[index] = Number.parseFloat(value);
		}
		setMonthlyKWh(newMonthlyKWh);
		parentKWHChange(newMonthlyKWh);
	};

	const handleIrrHardware = (event) => {
		setIrrHardware(event.target.value);
		//setPumpInputs({ ...pumpinputs, prehp: event.target.value });
		parentIrrHardwareChange(event.target.value);
	};

	const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	const totalKwh = monthlyKWh.reduce((sum, v) => sum + v, 0);
	const cellPadding = 4;

	return (
		<div style={{ marginTop: 10 }}>
			<GridContainer direction="column" justifyContent="flex-start" alignItems="flex-start">
				<GridItem xs={11} sm={11} md={11}>
					<div style={{ marginTop: "10px", width: "max-content" }}>
						<InputLabel htmlFor="htmlkwh">
							Enter the monthly kWh from all of the utility meters that power your current irrigation system:
						</InputLabel>
					</div>
				</GridItem>

				<GridItem xs={11} sm={11} md={11}>
					<div style={{ marginTop: "10px", width: "max-content" }}>
						<table style={{ borderCollapse: "collapse", textAlign: "left" }}>
							<thead>
								<tr>
									<th style={{ padding: cellPadding, paddingRight: 24 }}>Month</th>
									<th style={{ padding: cellPadding }}>kWh</th>
									<th style={{ padding: cellPadding, paddingRight: 24 }}>Month</th>
									<th style={{ padding: cellPadding }}>kWh</th>
								</tr>
							</thead>
							<tbody>
								{Array.from(Array(6).keys()).map((index) => {
									const rowData = [
										[monthLabels[index], monthlyKWh[index]],
										[monthLabels[index + 6], monthlyKWh[index + 6]],
									];
									return (
										<tr key={index}>
											{rowData.map(([label, value], columnIndex) => {
												const monthIndex = index + columnIndex * 6;
												return (
													<React.Fragment key={columnIndex}>
														<td style={{ padding: cellPadding }}>{label}</td>
														<td style={{ padding: cellPadding, paddingRight: 24 }}>
															<TextField
																type="number"
																variant="outlined"
																size="small"
																value={value === null ? "" : value}
																onChange={(e) => handleKwhMonthChange(monthIndex, e.target.value)}
																inputProps={{ min: 0, tabIndex: monthIndex + 1 }}
																style={{ width: 120 }}
															/>
														</td>
													</React.Fragment>
												);
											})}
										</tr>
									);
								})}
								{/* <tr>
									<td colSpan={3} style={{ fontWeight: "bold", paddingTop: 8 }}>
										Cumulative Yearly kWh Use:
									</td>
									<td style={{ fontWeight: "bold", paddingTop: 8 }}>{totalKwh} kWh</td>
								</tr> */}
							</tbody>
						</table>
						<p style={{ fontWeight: "bold", marginTop: 8 }}>Cumulative Yearly kWh Use: {totalKwh} kWh</p>
					</div>
				</GridItem>
			</GridContainer>

			<GridContainer direction="column" justifyContent="flex-start" alignItems="flex-start">
				<GridItem xs={11} sm={11} md={11}>
					<div style={{ marginTop: "30px", width: "max-content" }}>
						<InputLabel htmlFor="htmlhardwareirr">
							Does any non-irrigation hardware draw electricity from the utility meters?
						</InputLabel>
					</div>
				</GridItem>
				<GridItem xs={11} sm={11} md={11}>
					<div style={{ marginTop: "10px", width: "max-content" }}>
						<Select
							labelId="labelhardwareirr"
							id="fieldhardwareirr"
							value={irrHardware}
							onChange={handleIrrHardware}
							label=""
						>
							<MenuItem value={0}>Yes</MenuItem>
							<MenuItem value={1}>No</MenuItem>
						</Select>
					</div>
				</GridItem>
			</GridContainer>
		</div>
	);
}
